import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingMember: false,
  isSearchingMembers: false,
  isFetchingPrintFile: false,
  isRefreshing: false,
  isFetchingOverallPerformance: false,

  result: [],
};

const eligibilityMeasuresReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEASURES_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_MEASURES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_MEASURES_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_MEMBER_MEASURES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMember: true,
      };

    case types.GET_MEMBER_MEASURES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMember: false,
      };

    case types.GET_MEMBER_MEASURES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMember: false,
      };

    case types.GET_MEASURE_MEMBERS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMembers: true,
      };

    case types.GET_MEASURE_MEMBERS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMembers: false,
      };

    case types.GET_MEASURE_MEMBERS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMembers: false,
      };

    case types.GET_MEMBER_MEASURE_PRINT_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingPrintFile: true,
      };

    case types.GET_MEMBER_MEASURE_PRINT_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingPrintFile: false,
      };

    case types.GET_MEMBER_MEASURE_PRINT_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingPrintFile: false,
      };

    case types.REFRESH_MEMBER_MEASURES_REQUEST:
      return {
        ...state,
        result: [],
        isRefreshing: true,
      };

    case types.REFRESH_MEMBER_MEASURES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isRefreshing: false,
      };

    case types.REFRESH_MEMBER_MEASURES_FAILURE:
      return {
        ...state,
        result: [],
        isRefreshing: false,
      };

    case types.GET_PROVIDER_OVERALL_PERFORMANCE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingOverallPerformance: true,
      };

    case types.GET_PROVIDER_OVERALL_PERFORMANCE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingOverallPerformance: false,
      };

    case types.GET_PROVIDER_OVERALL_PERFORMANCE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingOverallPerformance: false,
      };

    default:
      return state;
  }
};

export default eligibilityMeasuresReducer;
